document.addEventListener('DOMContentLoaded', function () {
  const alphabetLinks = document.querySelectorAll('.brand-alphabet a');

  alphabetLinks.forEach(link => {
    link.addEventListener('click', function (e) {
      e.preventDefault();

      const targetId = this.getAttribute('href');
      const target = document.querySelector(targetId);

      if (!target) return;

      const headerOffset = 100; // adjust if needed
      const elementPosition = target.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    });
  });
});